import type { CSSProperties } from 'react';

export const LISTING_PRIMARY_BUTTON_CLASS =
  'font-semibold transition-colors hover:opacity-90 disabled:opacity-60';

export function listingPrimaryButtonStyle(
  background: string,
  text: string,
): CSSProperties {
  return {
    backgroundColor: background,
    color: text,
  };
}
